// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__1C52I","content":"Modal_content__utlUG","heading":"Modal_heading__8NJS0","close":"Modal_close__M1oFK"};